import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { getUser } from '../redux/actions/AccountSetting';
import { getUser as getUserSelector } from '../redux/selectors/accountSettingSelector';
import { CorporationsApi } from '../redux/api/CorporationsApi';
import CorporateNumberAssign from '../components/CorporateNumberAssign/CorporateNumberAssign';

const mapStateToProps = (state) => ({
  user: getUserSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  goTo(url, state) {
    dispatch(push(url, state));
  },

  getUserInfo() {
    dispatch(getUser());
  },

  assignCorporateNumber(formData) {
    return CorporationsApi.postAssignCorporateNumber(formData, dispatch);
  },

  startCorporateNumberAssignAsync(formData) {
    return CorporationsApi.postAssignCorporateNumberAsync(formData, dispatch);
  },

  getCorporateNumberAssignAsyncStatus(jobId) {
    return CorporationsApi.getAssignCorporateNumberAsyncStatus(jobId, dispatch);
  },

  getCorporateNumberAssignAsyncResult(jobId) {
    return CorporationsApi.getAssignCorporateNumberAsyncResult(jobId, dispatch);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CorporateNumberAssign);



// WEBPACK FOOTER //
// ./src/containers/CorporateNumberAssign.js